import { usePostHog } from "@posthog/react";
import { createFileRoute } from "@tanstack/react-router";
import { MotionConfig } from "motion/react";
import { useEffect, useState } from "react";

import { CardsSwapping } from "@/components/animations/cards-swapping";
import { ProtectedLayout } from "@/components/layout/protected";
import { ProfileForm } from "@/components/onboarding/profile-information";
import { UseCaseInformation } from "@/components/onboarding/usecase-information";
import { Brand } from "@/components/ui/brand";
import { onOnboardingStartedEvent } from "@/events/onboarding";
import { useAuthenticationStore } from "@/store/authentication";

export const Route = createFileRoute("/onboarding")({
  component: () => (
    <ProtectedLayout mode="onboarding">
      <Onboarding />
    </ProtectedLayout>
  ),
});

function Onboarding() {
  const company = useAuthenticationStore((state) => state.profile.company);

  const posthog = usePostHog();
  const [stage, setStage] = useState<"profile" | "usecase">(() => (!company || !company.company_name || !company.company_website ? "profile" : "usecase"));

  useEffect(() => {
    onOnboardingStartedEvent({}, { posthog });
  }, [posthog]);

  return (
    <main className="grid grid-cols-1 lg:grid-cols-2 relative">
      <Brand className="absolute top-4 left-4 lg:top-8 lg:left-8">
        <Brand.Icon />
        <Brand.Text />
      </Brand>
      {stage === "profile" ? (
        <MotionConfig transition={mTransition}>
          <section className="px-4 lg:px-8 py-16 flex items-center justify-center w-full max-w-xl mx-auto min-h-[100dvh]">
            <div className="grow-1 shrink-0">
              <ProfileForm setStage={setStage} />
            </div>
          </section>
        </MotionConfig>
      ) : (
        <MotionConfig transition={mTransition}>
          <section className="px-4 lg:px-8 py-16 flex items-center justify-center w-full max-w-xl mx-auto min-h-[100dvh]">
            <div className="grow-1 shrink-0">
              <UseCaseInformation />
            </div>
          </section>
        </MotionConfig>
      )}
      <CardsSwapping />
    </main>
  );
}

const mTransition = {
  duration: 0.2,
  ease: "easeOut",
  layout: {
    duration: 0.2,
    ease: "easeOut",
  },
};
